import PropTypes from 'prop-types';
import { useRef } from 'react';
import styled from 'styled-components';

import Exclamation from '~/components/Elements/Exclamation';
import Tooltip from '~/components/Tooltip';
import { colors } from '~/utils/css-mixins';

let uniqueId = 0;
const getUniqueId = () => uniqueId++;
const useUniqueId = prefix => {
  const idRef = useRef(getUniqueId());
  return `${prefix}_${idRef.current}`;
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const ValueWrapper = styled.span`
  margin-right: 3px;
  color: ${props => (props.changed ? colors.change : undefined)};
  ${props =>
    props.changed &&
    props['data-tooltip-id'] &&
    `
    text-decoration: underline dotted;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  `}
`;

const IconWrapper = styled.span`
  flex-shrink: 0;
  line-height: 0;
`;

const ItemRenderer = ({
  isFirstTime,
  changed,
  showTooltip,
  previousValue,
  children,
  className,
}) => {
  const tooltipId = useUniqueId('tooltip');
  const tooltipEnabled = showTooltip && changed && previousValue != null;

  return (
    <Wrapper className={className}>
      <ValueWrapper
        changed={changed}
        {...{
          'data-tooltip-id': tooltipEnabled ? tooltipId : undefined,
        }}
      >
        {children}
      </ValueWrapper>
      {isFirstTime && (
        <IconWrapper>
          <Exclamation />
        </IconWrapper>
      )}
      {tooltipEnabled && (
        <Tooltip id={tooltipId}>
          <em>Senast:</em> {previousValue}
        </Tooltip>
      )}
    </Wrapper>
  );
};

ItemRenderer.propTypes = {
  isFirstTime: PropTypes.bool,
  changed: PropTypes.bool,
  showTooltip: PropTypes.bool,
  previousValue: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default ItemRenderer;
